import { render } from "./ReminderMessageAddConditionConfirmPage.vue?vue&type=template&id=a5171a7c&scoped=true"
import script from "./ReminderMessageAddConditionConfirmPage.vue?vue&type=script&lang=js"
export * from "./ReminderMessageAddConditionConfirmPage.vue?vue&type=script&lang=js"

import "./ReminderMessageAddConditionConfirmPage.vue?vue&type=style&index=0&id=a5171a7c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5171a7c"]])

export default __exports__